module.exports = __webpack_public_path__ + "static/media/about_img2.2a966173.jpg";